import React, { useEffect } from "react";
import { Col, Row, Container, Card, Form, Button } from "react-bootstrap";
import { useInView } from "react-intersection-observer";
import { NavLink } from "react-router-dom";
import { useAnimation, motion } from "framer-motion";
import ReCAPTCHA from "react-google-recaptcha";

import TitleTabs from "../../components/Title";
import { ROUTES } from "../../constants/routes";
import { carreraData } from "../../constants/carreraData";

import "../../styles/components/Oferta.scss";

const boxVariant = {
  visible: { opacity: 1, y: 0, transition: { duration: 1 } },
  hidden: { opacity: 0, y: 200 },
};

export default function Oferta() {
  const control = useAnimation();
  const [ref, inView] = useInView();
  const onChange = () => {
    console.log("Hubo un cambio")
  }

  useEffect(() => {
    if (inView) {
      control.start("visible");
    }
  }, [control, inView]);

  return (
    <div className="Oferta mt-5">
      <motion.div
        className="box"
        ref={ref}
        variants={boxVariant}
        initial="hidden"
        animate={control}
      >
        <Container>
          <Row>
            <Col xs={12} sm={12} md={5} lg={5} xl={5} xxl={5}>
              <Row className="text-black title">
                <TitleTabs titulo="¡Forma parte de nuestro Equipo de trabajo!"/>
              </Row>
              <Row className="text-black text">
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
                </p>
                <p>
                  Puedes realizar tus practicas profesionales con nosotos tu CV
                </p>
              </Row>
            </Col>
            <Col
              xs={12}
              sm={12}
              md={7}
              lg={7}
              xl={7}
              xxl={7}
              className="p-4 backgroundGray"
            >
              <Card.Body>
                <Form>
                  <Form.Group className="mb-3" controlId="formBasicNombre">
                    <Form.Label className="text-white">
                      Nombre Completo
                    </Form.Label>
                    <Form.Control type="text" placeholder="Nombre Completo" />
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Label className="text-white">Correo</Form.Label>
                    <Form.Control type="email" placeholder="Correo" />
                  </Form.Group>

                  <Form.Group controlId="formFile" className="mb-3">
                    <Form.Label className="text-white">Adjunta tu CV</Form.Label>
                    <Form.Control type="file" />
                  </Form.Group>

                  <Form.Group controlId="formFile" className="mb-3">
                    <Form.Label className="text-white">Carrera Afin</Form.Label>
                    {["radio"].map((type: any) => (
                      <div key={`${type}`} className="mb-3">
                        {carreraData.map((data: any) => (
                          <Form.Check
                            className="text-white"
                            label={data.label}
                            name="group1"
                            type={type}
                            id={data.id}
                          />
                        ))}
                        <div className="d-flex">
                          <Form.Check
                            className="text-white"
                            label="Otro"
                            type={type}
                            name="group1"
                            id={`${type}-4`}
                          />
                          <Form.Control
                            type="text"
                            className="ms-2"
                            placeholder="Otra carrera"
                          />
                        </div>
                      </div>
                    ))}
                  </Form.Group>
                  <div className="captcha">
                    <ReCAPTCHA
                      sitekey="6LdMcwUnAAAAABPw0fwLQGOTjjurT5MxNbITrOUS"
                      onChange={onChange}
                      size="invisible"
                    />
                  </div>   
                  <NavLink to={ROUTES.OFERTA} className="d-flex justify-content-end link">
                    <Button className="botonColor" type="submit" size="lg">
                      Postularme
                    </Button>
                  </NavLink>                              
                </Form>
              </Card.Body>
            </Col>
          </Row>
        </Container>        
      </motion.div>
    </div>
    
  );
}
